module.exports = __webpack_public_path__ + "static/media/pii3.061741c9.jpg";